import AboutPage from "../page/About";
import CatalogDetailPage from "../page/CatalogDetail";
import ContactPage from "../page/Contact";
import HomePage from "../page/Home";
import FormLogin from "../page/Login";
import FormRegister from "../page/Register";
import PageNotFound from "./PageNotFound";

export const publicRoute = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/login/admin",
    element: <FormLogin />,
  },
  {
    path: "/register",
    element: <FormRegister />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/catalog/:id",
    element: <CatalogDetailPage />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
